import { AppBar, Button, Toolbar, Typography, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import HBARLogo from "../assets/branding.svg";
import { useWalletInterface } from '../services/wallets/useWalletInterface';
import { WalletSelectionDialog } from './WalletSelectionDialog';
import { NetworkSwitch } from './NetworkSelectSwitch';

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const { accountId, walletInterface } = useWalletInterface();

  const handleConnect = async () => {
    if (accountId) {
      walletInterface.disconnect();
    } else {
      setOpen(true);
    }
  };

  useEffect(() => {
    if (accountId) {
      setOpen(false);
    }
  }, [accountId]);

  return (
    <AppBar position="relative">
      <Toolbar>
        <img
          src={HBARLogo}
          alt="An upper case H with a line through the top"
          className="hbarLogoImg"
        />

        <Typography variant="h6" color="white" pl={1} noWrap>
          Sealcoin internal
        </Typography>

        {/* push right-side controls */}
        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 2 }}>
          {/* Network toggle */}
          <NetworkSwitch />

          {/* Connect button */}
          <Button variant="contained" onClick={handleConnect}>
            {accountId ? `Connected: ${accountId}` : "Connect Wallet"}
          </Button>
        </Box>
      </Toolbar>

      <WalletSelectionDialog
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
      />
    </AppBar>
  );
}
